import {createContext, Dispatch, SetStateAction} from "react";

export interface NavBarContextProps {
    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
}

export const NavBarContext = createContext<NavBarContextProps | null>(null);
